(function() {
    'use strict';
    
    // 1. LEER GCLID DE LA COOKIE
    function getCookie(name) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(';');
        for(var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return decodeURIComponent(cookie.substring(nameEQ.length));
            }
        }
        return null;
    }
    
    // 2. MANTENER GCLID EN LINKS INTERNOS (lo que ya hacías)
    var gclid = getCookie('gclid');
    if (gclid) {
        function appendGclid(url) {
            try {
                var u = new URL(url, location.origin);
                if (!u.searchParams.get('gclid')) {
                    u.searchParams.set('gclid', gclid);
                    return u.toString();
                }
            } catch(e) {}
            return url;
        }
        
        document.querySelectorAll('a[href^="/"]').forEach(function(a) {
            a.href = appendGclid(a.href);
        });
        
        document.body.addEventListener('click', function(evt) {
            var el = evt.target.closest('a[href]');
            if (el && el.getAttribute('href').startsWith('/')) {
                el.href = appendGclid(el.href);
            }
        }, true);
    }
    
    // 3. ENVIAR GCLID A GOOGLE ADS EN PÁGINA DE CONFIRMACIÓN
    if (window.location.pathname.includes('/orders') || 
        window.location.pathname.includes('/thank_you')) {
        
        setTimeout(function() {
            var gclidValue = getCookie('gclid');
            
            if (gclidValue && typeof gtag === 'function') {
                console.log('📍 Enviando gclid a Google Ads:', gclidValue);
                
                gtag('event', 'conversion', {
                    'send_to': 'AW-1034363672/jLMxCPSasq0DEJjGnO0D',
                    'gclid': gclidValue,
                    'currency': 'EUR'
                });
            } else {
                console.log('⚠️ gclid no encontrado o gtag no disponible');
            }
        }, 1000);
    }
})();
